import { render, staticRenderFns } from "./MyApi.vue?vue&type=template&id=ca4fb0d6&scoped=true"
import script from "./MyApi.vue?vue&type=script&lang=js"
export * from "./MyApi.vue?vue&type=script&lang=js"
import style0 from "./MyApi.vue?vue&type=style&index=0&id=ca4fb0d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4fb0d6",
  null
  
)

export default component.exports